import WhatsappChat from '@kopapro/components/misc/whatsappChat/whatsappChat';

export default WhatsappChat;
